import React, { useState, useEffect } from 'react';
import './EmbedCode.css';

const EmbedCode = () => {
  const [userId, setUserId] = useState(null);
  const [embedCode, setEmbedCode] = useState('');

  useEffect(() => {
    // Get user ID from localStorage
    const storedUserId = localStorage.getItem('userId');
    if (storedUserId) {
      setUserId(storedUserId);
      // Use localhost for development, or replace with your domain in production
      const widgetUrl = window.location.origin.includes('localhost') 
        ? 'http://localhost:3000/widget.js'
        : `${window.location.origin}/widget.js`;
      setEmbedCode(`<script src="${widgetUrl}" data-client-id="${storedUserId}"></script>`);
    }
  }, []);

  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(embedCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (!userId) {
    return (
      <div className="embed-code-page">
        <h2>Embed Code</h2>
        <div className="embed-card">
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="embed-code-page">
      <h2>Embed Code</h2>
      <div className="embed-card">
        <p className="embed-description">
          Copy and paste this code into your website's HTML, just before the closing <code>&lt;/body&gt;</code> tag.
          <br />
          <small style={{ color: '#64748b', fontSize: '0.85rem', marginTop: '0.5rem', display: 'block' }}>
            Note: For production, make sure to set <code>window.FIGBOT_API_URL</code> to your backend API URL before loading the widget script.
          </small>
        </p>
        <div className="code-container">
          <pre className="code-block">{embedCode}</pre>
          <button onClick={copyToClipboard} className="copy-btn" disabled={!embedCode}>
            {copied ? '✓ Copied!' : 'Copy Code'}
          </button>
        </div>
        <div className="embed-preview">
          <h3>Preview</h3>
          <div className="preview-box">
            <div className="chatbot-widget-preview">
              <div className="widget-header">Your Chatbot</div>
              <div className="widget-messages">
                <div className="widget-message bot">Hello! How can I help you today?</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmbedCode;
